import React from 'react';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="bg-forest-900 text-forest-50/60 py-12 px-4 text-center border-t border-forest-800" data-id="element-44">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-45">
        <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-46">
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-47">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-48">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-49">
            Contacto
          </a>
        </div>

        <p className="text-xs mt-8" data-id="element-50">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          <br data-id="element-51" />
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>

        <p className="text-sm font-medium" data-id="element-52">📩 soportebiomalivido@gmail.com</p>

        <div className="text-sm space-y-1" data-id="element-53">
          <p data-id="element-54">© 2026 BIOMA LÍVIDO. Todos los derechos reservados.</p>
          <p data-id="element-55">
            Protocolo Rescate SIBO™ es una marca registrada de BIOMA LÍVIDO
          </p>
        </div>
      </div>
    </footer>;
}